import { Endpoint } from '../endpoint';
import { CommonService } from '@business/services';
import {
  OrderEmailTemplateRequest,
  TMChangeOrdeRDepositCardRequest,
  TMChangeOrderDepositAchRequest,
  TMChangeOrderId,
  TMChangeOrderResponse,
} from '@business/entities/tm';
import { ChangeOrderFormData } from '@modules/timeMaterials/AddEditTMChangeOrderPage/TMChangeOrderForm';

export function fetchChangeOrders(tmId: string) {
  return Endpoint.get<TMChangeOrderResponse[]>(`@gc/tm-change-order`, { params: { tmId } });
}

export function fetchChangeOrder(id: TMChangeOrderId) {
  return Endpoint.get<TMChangeOrderResponse>(`@gc/public/tm-change-order/change-order/${id}`);
}

export function createOrder(data: ChangeOrderFormData) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<TMChangeOrderResponse>(`@gc/tm-change-order`, { formData, hasFiles: true });
}

export function sendCO(id: TMChangeOrderId, data: OrderEmailTemplateRequest) {
  return Endpoint.post<TMChangeOrderResponse>(`@gc/tm-change-order/send-co/${id}`, { data });
}

export function onSigned(id: TMChangeOrderId, sign: string, amount: number) {
  return Endpoint.post<TMChangeOrderResponse>(`@gc/public/tm-change-order/on-signed/${id}`, { data: { sign, amount } });
}

export function payWithACH(id: TMChangeOrderId, data: TMChangeOrderDepositAchRequest) {
  return Endpoint.post<TMChangeOrderResponse>(`@gc/tm-co-payment/ach/${id}`, { data });
}

export function payWithCard(id: TMChangeOrderId, data: TMChangeOrdeRDepositCardRequest) {
  return Endpoint.post<TMChangeOrderResponse>(`@gc/tm-co-payment/card/${id}`, { data });
}

export function deleteCO(id: TMChangeOrderId) {
  return Endpoint.delete(`@gc/tm-change-order/${id}`);
}
